import styled from "styled-components";

import { Box, colors } from "@mui/material";

export const WeddingInvitationContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	.invitation-wrapper {
		width: 430px;
		min-height: 100vh;
		transition: opacity 2s ease-in-out;
		transition-delay: 2s;
		height: 100vh;
		overflow: hidden;

		&.show {
			opacity: 1;
		}

		&.hide {
			opacity: 0;
			z-index: -1;
		}

		.animate-on-scroll {
			opacity: 0;
			transform: translateY(20px);

			transition:
				opacity 0.8s ease-out,
				transform 0.8s ease-out;
		}

		.animate-on-scroll.visible {
			opacity: 1;
			transform: translateY(0);
		}

		.delay-1 {
			transition-delay: 0.2s;
		}

		.delay-2 {
			transition-delay: 0.4s;
		}
		.delay-3 {
			transition-delay: 0.6s;
		}
		.delay-4 {
			transition-delay: 0.8s;
		}
		.delay-5 {
			transition-delay: 1s;
		}
	}
	.template-color-selector {
		position: fixed;
		top: 10px;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		width: 230px;
		background: rgba(0, 0, 0, 0.6);
		z-index: 10;
		padding: 5px;
		border-radius: 5px;
	}
	.template-entrance-selector {
		position: fixed;
		top: 70px;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		width: 230px;
		background: rgba(0, 0, 0, 0.6);
		z-index: 10;
		padding: 0 5px;
		border-radius: 5px;
	}
	.invitation-buy-button {
		position: fixed;
		bottom: 20px;
		width: 280px;
		left: 0;
		right: 0;
		margin-left: auto;
		z-index: 1000;
		margin-right: auto;
		color: #fff;
		transition: opacity 2s ease-in-out;
		transition-delay: 2s;
		&.show {
			opacity: 1;
		}

		&.hide {
			opacity: 0;
			z-index: -1;
		}

		&.Mui-disabled {
			color: ${colors.grey[400]};
		}
	}

	.response_wrapper {
		position: fixed;
		background: rgba(0, 0, 0, 0.7);
		top: 20px;
		width: 280px;
		padding: 8px 10px;
		border-radius: 10px;
		z-index: 1000;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		transition: opacity 2s ease-in-out;
		transition-delay: 2s;

		&.show {
			opacity: 1;
		}

		&.hide {
			opacity: 0;
			z-index: -1;
		}
		.label {
			color: #fff;
			font-weight: bold;
			display: flex;
			justify-content: center;
			gap: 5px;
			font-size: 14px;
		}

		.invitation-rsvp-button {
			background: ${({ theme }) => theme.palette.secondary.dark};
			padding: 5px 8px;

			&:hover {
				background: ${({ theme }) => theme.palette.secondary.light};
			}

			svg {
				margin-right: 5px;
			}
		}
	}

	.invitation-control-bar {
		position: fixed;
		background: rgba(24, 24, 26, 0.55);
		backdrop-filter: blur(16px) saturate(160%);
		-webkit-backdrop-filter: blur(16px) saturate(160%);
		border: 1px solid rgba(255, 255, 255, 0.16);
		top: 20px;
		width: fit-content;
		padding: 10px 16px;
		border-radius: 22px;
		z-index: 1000;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		justify-content: center;
		gap: 16px;
		align-items: center;
		box-shadow:
			0 10px 30px rgba(0, 0, 0, 0.28),
			0 2px 8px rgba(0, 0, 0, 0.2);
		transition: opacity 2s ease-in-out;
		transition-delay: 2s;
		&.show {
			opacity: 1;
		}

		&.hide {
			opacity: 0;
			z-index: -1;
		}

		.location-menu-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 5px;
			padding: 0;
			transition: transform 0.2s ease;

			.icon {
				border-radius: 50%;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 38px;
				height: 38px;
				background: rgba(255, 255, 255, 0.16);
				border: 1px solid rgba(255, 255, 255, 0.22);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
				transition:
					transform 0.2s ease,
					box-shadow 0.2s ease,
					background 0.2s ease;

				svg {
					fill: white;
					width: 18px;
				}
			}

			&:hover:not(.disabled) .icon {
				transform: translateY(-2px) scale(1.06);
				box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
			}

			&:active:not(.disabled) .icon {
				transform: translateY(0) scale(0.98);
			}

			&.disabled {
				opacity: 0.5;

				.icon {
					background: rgba(255, 255, 255, 0.06);
					box-shadow: none;
				}
				svg {
					fill: ${colors.grey[400]};
				}
				p {
					color: ${colors.grey[400]};
				}
			}
			p {
				font-size: 12px;
				font-weight: 600;
				color: #ffffff;
				text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
			}
		}
		&.rtl {
			.location-menu-item {
				p {
					font-size: 16px;
				}
			}
		}
	}
	.notification_bell_wrapper {
		position: fixed;
		bottom: 40px;
		right: 10px;
		border-radius: 10px;
		z-index: 1000;
		background: rgba(0, 0, 0, 0.6);
		padding: 7px;
		transition: opacity 2s ease-in-out;
		transition-delay: 2s;
		&.show {
			opacity: 1;
		}

		&.hide {
			opacity: 0;
			z-index: -1;
		}

		button {
			background: ${({ theme }) => theme.palette.secondary.dark};

			svg {
				fill: white;
			}
		}
	}

	${props => props.theme.breakpoints.down("sm")} {
		.invitation-wrapper {
			width: 100%;
		}
	}
`;
